import { useState } from "react";
import { get } from "../../api/apiShared.ts";
import { EntityType } from "../../Common.types.ts";
import { usePlanContext } from "../../../auth/planProvider/PlanProvider.tsx";
import { useDebounce } from "../../hooks/useDebounce.hooks.ts";
import { DocumentEntityType, mapDocumentEntityTypeToEntityType, SearchResultViewModel } from "./SearchResultList.types.ts";

export { DocumentEntityType, mapDocumentEntityTypeToEntityType };

export const useSearchResultList = (fetchUsers: boolean) => {
    const [showMoreForEntityType, setShowMoreForEntityType] = useState<EntityType | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [suggestions, setSuggestions] = useState<Array<SearchResultViewModel>>([]);
    const { platformFeatures, addonsFeatures } = usePlanContext();

    const debouncedFetchSuggestions = useDebounce(async (value: string, forEntityType?: EntityType) => {
        await fetch(value, forEntityType);
    }, 1000);

    const fetchSuggestions = async (query: string) => {
        debouncedFetchSuggestions(query, showMoreForEntityType);
        setIsLoading(true);
    };

    const fetchSuggestionsForEntity = async (forEntityType: EntityType, query: string) => {
        debouncedFetchSuggestions(query, forEntityType);
        setIsLoading(true);
    };

    const initSuggestions = async () => {
        await fetch("");
    };

    const fetch = async (query: string, forEntityType?: EntityType) => {
        if (platformFeatures.canAccessRelationsBetweenEntities && !addonsFeatures.research) {
            setIsLoading(true);
            const response = await get<Array<SearchResultViewModel>>(`/search?query=${query}&fetchUsers=${fetchUsers}&entityType=${forEntityType}`);

            setSuggestions(response);
            setIsLoading(false);
        }
    };

    const onShowMoreForEntityTypeClick = (query: string, entityType: EntityType | undefined) => {
        setShowMoreForEntityType(entityType);
        fetch(query, entityType);
    };

    return {
        isLoading,
        entitySearchSuggestions: suggestions,
        fetchSuggestions,
        initSuggestions,
        setSuggestions,
        onShowMoreForEntityTypeClick: onShowMoreForEntityTypeClick,
        setShowMoreForEntityType,
        isEntitySpecificSearch: showMoreForEntityType !== undefined,
        fetchSuggestionsForEntity,
    };
};
